export default __webpack_public_path__ + "e797b5857591d707f6fd056ce123047a.png";